// Generated by purs version 0.15.16
import * as Control_Monad_Identity_Trans from "../Control.Monad.Identity.Trans/index.js";
var lower = function (dict) {
    return dict.lower;
};
var comonadTransIdentityT = {
    lower: function (dictComonad) {
        return Control_Monad_Identity_Trans.runIdentityT;
    }
};
export {
    lower,
    comonadTransIdentityT
};
//# sourceMappingURL=index.js.map
